import { render } from "./Team_post_investment.vue?vue&type=template&id=6e6bbcf3&scoped=true"
import script from "./Team_post_investment.vue?vue&type=script&lang=js"
export * from "./Team_post_investment.vue?vue&type=script&lang=js"

import "./Team_post_investment.vue?vue&type=style&index=0&id=6e6bbcf3&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6e6bbcf3"

export default script